<script>
  import AutoCompleteComponent from "../AutoCompleteComponent.svelte";
  import { modalReservation, User } from "../../store";
  import fetchNodeProduction from "../../helpers/FetchNodeProduction.js";
  import { DateTime } from 'luxon';
  let loading = false;
  export let message;
  export let error;
  let transferType;
  let reservation;
  let isOverbooking = false;
  let isMidstayRelocation = false;
  let midStayStartDate;
  // property related
  let targetAirbetterId;
	const propertyClause = {isArchived:0,isActive:1};

  modalReservation.subscribe((value) => {
    reservation = value;
    const reservationCheckInDate = DateTime.fromISO(value.dateFrom);
    const today = DateTime.local();
    if(today < reservationCheckInDate){
      midStayStartDate = reservationCheckInDate.toISODate();
    } else {
      midStayStartDate = today.toISODate();
    }
  });
  let transferTypes = [{"value":"1","name":"keep for hosts"},{"value":"0","name":"hide for hosts"}];

  function parseMessage(data) {
    const { message } = data;
    if (message == "token expired") { 
      User.logout();
    }
    if (message.part1) {
      return `${message.part1 || ""} ${message.part2 || ""} ${
        message.part3 || ""
      } ${message.part4 || ""}`;
    }
    return message;
  }
  async function submitForm() {
    try {
      error = "";
      message = "";
      loading = true;
      const formDataDefaults = new FormData(document.getElementById('transferForm'));
      const isMidStayRelocation = formDataDefaults.get('isMidstay') == 'on'? true:false;
      const isOverbooking = formDataDefaults.get('allowOverbooking') == 'on'? true:false;
      const formData = new FormData();
      formData.append("reservationId", reservation.id);
      formData.append("targetAirbetterId", targetAirbetterId);
      if(isMidStayRelocation === true) {
        formData.append('isMidStayRelocation', 'true');
      } else {
        formData.append('isMidStayRelocation', 'false');
      }
      if(isOverbooking === true) {
        formData.append('isOverbooking', 'true');
      } else {
        formData.append('isOverbooking', 'false');
      }
      formData.append('midStayStartDate', midStayStartDate);
      formData.append("transferType", transferType);
      let response = await fetchNodeProduction(
        "/transferReservation",
        formData
      );
      if (typeof response === "object") {
        if (response.status == true) {
          message = parseMessage(response.data);
        } else {
          error = parseMessage(response);
        }
      }
      loading = false;
    } catch (ex) {
      console.log(ex);
    } finally {
      loading = false;
    }
  }
</script>


<form on:submit|preventDefault={submitForm} id=transferForm>
  <div class='form-control'>
    <AutoCompleteComponent node='property' placeholder="New Property ID" bind:selected={targetAirbetterId} valueFieldName='id' labelFieldName='airbetterName' clause={propertyClause} />
  </div>
  <div class='form-control'>
    <label for="transfer">Original reservation</label>
    <select name="transfer" bind:value={transferType}>
      {#each transferTypes as type}
      <option value="{type.value}">{type.name}</option>
      {/each}
    </select>
  </div>
  <div class='form-control-row'>
    <input name="allowOverbooking" type="checkbox" bind:checked={isOverbooking}/>
    <label for="allowOverbooking">Allow overbooking on original property</label>
  </div>
  <div class='form-control-row'>
    <input name="isMidstay" type="checkbox" bind:checked={isMidstayRelocation}/>
    <label for="isMidstay">Set midstay relocation</label>
  </div>
  {#if isMidstayRelocation}
    <div class='form-control'>
      <label for="midStayStartDate">Arrival date</label>
      <input name="midStayStartDate" type="text" bind:value={midStayStartDate}/>
    </div>
  {/if}
  <button type="submit" class="pink-button" disabled={loading} >  
      {loading ? "Loading..." : "Transfer Reservation"}
  </button>
</form>
{#if error}
  <small>
    <strong>
      <p class="red-font">
        {error}
      </p>
    </strong>
  </small>
{/if}
{#if message}
  <small>
    <strong>
      <p class="blue-font">
        {message}
      </p>
    </strong>
  </small>
{/if}
<style>
  .pink-button {
    background-color: #ed4368;
    color: #fff;
    margin-top: 10px;
    width: 100%;
  }
  .red-font {
    color: rgb(194, 32, 32);
  }
  .form-control-row {
    display:flex;
    flex:1;
    flex-direction: row;
    padding-top: 15px;
  }
  input[type=checkbox]{
    margin-right: 15px;
  }

  .form-control {
    display:flex;
    flex:1;
    flex-direction: column;
    padding-top: 15px;

  }
  .form-control label{
    margin-top: 10px;
    margin-bottom: 10px;
  }
</style>
